import {
	ChangeDetectorRef, Component, ElementRef, Inject, OnInit
}                                                                                 from '@angular/core';
import { DomSanitizer, SafeHtml }                                                 from '@angular/platform-browser';
import { DataTransforms }                                                         from '@cs/common';
import { FormatProviderService }                                                  from '@cs/common/culture';
import { CsPopoverData, CsPopoverOverlayBase, CsPopoverOverlayRef, GridDataCell } from '@cs/components/data-grid';
import { FilterCompareBarQuery }                                                  from '@cs/components/filter-and-compare-bar';
import { LookupAgent }                                                            from '@cs/components/shared';
import { isNullOrUndefined }                                                      from '@cs/core';
import { LoggerUtil, replacePlaceholders, replacePlaceholdersWithExpressions }    from '@cs/core/utils';
import { TranslateService }                                                       from '@ngx-translate/core';
import { Observable }                                                             from 'rxjs';

@Component({
												standalone: false,
												selector   : 'pmc-data-source-html-hover',
												templateUrl: './data-source-html-hover.component.html'
											})

export class DataSourceHtmlHoverComponent extends CsPopoverOverlayBase implements OnInit {

	mainPresetLabel$: Observable<string>;
	comparebarPresetLabel$: Observable<string>;
	offsetPresetLabel$: Observable<string>;

	datasources: Array<any>;
	compareDatasources: Array<any>;
	datasourceGroupProperty: string;
	hasCompareCell: boolean;
	hasCompareData: boolean;

	htmlContent: SafeHtml;
	itemForMapping: any;
	dateUpdate: string;

	constructor(public element: ElementRef,
													private sanitizer: DomSanitizer,
													public cdr: ChangeDetectorRef,
													@Inject(FilterCompareBarQuery) public filterCompareBarQuery: FilterCompareBarQuery,
													@Inject(CsPopoverData) public data: GridDataCell,
													@Inject(FormatProviderService) private format: FormatProviderService,
													@Inject(TranslateService) private i8n: TranslateService,
													@Inject(CsPopoverOverlayRef) public overlayRef: CsPopoverOverlayRef) {
		super();
		const clone = data.cellData.map(item => Object.assign({}, item));

		// check if there is a compare cell
		this.hasCompareCell = !isNullOrUndefined(data.compareCell);

		// Get datasource grouping property from tooltip action (set via grid rules), default to 'iddatasource'
		this.datasourceGroupProperty = data.tooltip?.datasourceGroupProperty || 'iddatasource';

		// Use groupDatasourcesByProperty to get grouped data with individual datasources preserved
		this.datasources = DataTransforms.groupDatasourcesByProperty(clone, this.datasourceGroupProperty);

		this.itemForMapping = {
			'CellDisplayValue':           this.format.formatByString(data.value, '{0:N2}'),
			'CellValue':                  data.value,
			'DatasourceBreakdown':        this.createDatasourceBreakdown(this.datasources, false, data.metaValues.relDifference),
			'CompareDatasourceBreakdown': ''
		};

		//	const template = '<div> ${DatasourceBreakdown}🧓👱‍♂️ <small>${CellValue}|format:\'{0:N3}\'</small>a das dasdads${CompareDatasourceBreakdown}</div>';
		let template = '${DatasourceBreakdown}${CompareDatasourceBreakdown}';
		if (data.tooltip?.templateHtml) {
			template = data.tooltip.templateHtml;
		} else {
			LoggerUtil.log('No template found. Using default breakdown');
		}

		if (this.hasCompareCell) {
			this.hasCompareData                               = data.compareCell.value !== null;
			const compareClone                          = data.compareCell.cellData.map(item => Object.assign({}, item));
			this.compareDatasources                           = DataTransforms.groupDatasourcesByProperty(compareClone, this.datasourceGroupProperty);
			this.itemForMapping['CompareDatasourceBreakdown'] = this.createDatasourceBreakdown(this.compareDatasources, true);
		}

		this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(replacePlaceholdersWithExpressions(this.itemForMapping, template, this.format));
	}

	ngOnInit(): void {
		super.initPopover();
		this.mainPresetLabel$       = this.filterCompareBarQuery.select(store => store.mainbarPresetLabel);
		this.comparebarPresetLabel$ = this.filterCompareBarQuery.select(store => store.comparebarPresetLabel);
		this.offsetPresetLabel$     = this.filterCompareBarQuery.select(store => store.offsetPresetLabel);


	}

	private createDatasourceBreakdown(datasources: any[], isCompare: boolean, relDifference?: number): string {
		let breakdown               = '';
		const mainPresetLabel       = this.filterCompareBarQuery.getValue().mainbarPresetLabel;
		const comparebarPresetLabel = this.filterCompareBarQuery.getValue().comparebarPresetLabel;
		const offsetPresetLabel     = this.filterCompareBarQuery.getValue().offsetPresetLabel;

		const label        = isCompare
																							? (comparebarPresetLabel)
																							: (mainPresetLabel);
		const compareLabel = (comparebarPresetLabel);

		const translatedPrefix   = this.i8n.instant('LAST_UPDATED');
		const translatedPrefixId = this.i8n.instant('DATASOURCE_ID') + ': ';

		// Get the lookup key based on grouping property
		const lookupKeyMap = this.getGroupPropertyLookupKey();

		// Check if we have only one group
	const isSingleGroup = datasources.length === 1;

	datasources.forEach((group, index) => {
		// Show main preset header for all groups
		breakdown += `<div class="d-flex flex-row justify-content-between data-row">
                <span class="data-hover-label text-truncate">${label} ${isCompare
																																																																								? ''
																																																																								: (relDifference && relDifference !== 0
																																																																											? `<span class="offset-label">(${this.format.formatByString((relDifference - 1) * 100, '{0:N2}')} %)</span>`
																																																																											: '')}</span>
                <span class="data-hover-value border-bottom-1">${this.format.formatByString(group.value, '{0:N2}')}</span>
            </div>`;

		// For multiple groups: show scenario/group header
		if (!isSingleGroup) {
			const groupPropertyValue = group[this.datasourceGroupProperty];
			const groupLookupKey = lookupKeyMap[this.datasourceGroupProperty] || 'IdDataSource';
			const groupLabel = this.getLookupValue(groupPropertyValue, groupLookupKey);

			const groupContent = `<div class="d-flex flex-row justify-content-between data-source-item data-row" style="font-weight: bold; padding: 4px 0;">
                ${this.wrapWithTooltip(`
                <span class="data-source-item-label text-truncate" >
                    <i class="mdi mdi-folder mr-1"></i> ${groupLabel}
                </span>`, groupPropertyValue, translatedPrefixId, 'left', 'large', 'mdi-folder')}
                <span class="data-hover">${this.format.formatByString(group.value, '{0:N2}')}</span>
            </div>`;

			breakdown += groupContent;
		}

		// Display individual datasources within the group
		if (group.datasources && Array.isArray(group.datasources)) {
			group.datasources.forEach(datasource => {
				const paddingStyle = isSingleGroup ? '' : 'padding-left: 20px; opacity: 0.8;';
				const datasourceContent = `<div class="d-flex flex-row justify-content-between data-source-item data-row" style="${paddingStyle}">
                 ${this.wrapWithTooltip(`
                <span class="data-source-item-label text-truncate" >
                    <i class="mdi mdi-database mr-1"></i> ${this.getLookupValue(datasource.iddatasource, 'IdDataSource')}
                </span>`, datasource.iddatasource, translatedPrefixId, 'left', 'large', 'mdi-database')}
                ${this.wrapWithTooltip(`<span class="data-hover">${this.format.formatByString(datasource.value, '{0:N2}')}</span>`, datasource.dateupdate, translatedPrefix, 'right', 'large', 'mdi-calendar-clock')}
            </div>`;

				breakdown += datasourceContent;
			});
		}
	});

		if (isCompare && !this.hasCompareData) {
			breakdown += `<div class="d-flex flex-row justify-content-between data-row">
                <span class="data-hover-label text-truncate">
                    <i class="mdi mdi-database mr-1"></i> ${compareLabel}
                </span>
                <span class="data-hover-value border-bottom-1">${this.i8n.instant('NO_DATA')}</span>
            </div>`;
		}


		return breakdown;
	}

	/**
		* Maps grouping property names to their corresponding lookup keys for UI display
		* @returns Map of grouping property to lookup key
		*/
	private getGroupPropertyLookupKey(): {
		[key: string]: string
	} {
		return {
			'iddatasource': 'IdDataSource',
			'idscenario':   'IdScenario'
			// Add more mappings as needed for other grouping properties
		};
	}

	private getLookupValue(value: any, lookupKey: string): any {
		if (isNullOrUndefined(value) || isNullOrUndefined(lookupKey)) return value;
		return LookupAgent.resolve(value, lookupKey);
	}

	private wrapWithTooltip(content: string, dateUpdate: string | undefined, prefix?: string, position: 'top' | 'bottom' | 'left' | 'right' = 'top', spacer: 'small' | 'medium' | 'large' = 'medium',
																									iconClass: string                                                                                                                                             = null): string {
		if (!dateUpdate) {
			return content;
		}
		const tooltipPrefix = prefix || this.i8n.instant('LAST_UPDATED');
		const icon          = iconClass
																								? `<i class="mdi ${iconClass}"></i>`
																								: '';
		return `<span class="custom-hover-tooltip custom-hover-tooltip-${position} custom-hover-tooltip-spacer-${spacer}">${content}<span class="custom-hover-tooltip-text">${icon}${tooltipPrefix} ${dateUpdate}</span></span>`;
	}

}
